export default __webpack_public_path__ + "static/media/gallery-wip-electronics_01.63ac136e.jpg";